export default "__VITE_ASSET__zgNe1K7C__"